










import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import VueRouter, { Location } from "vue-router";
import DWInstrumentNavigation from "./DWInstrumentNavigation.vue";
import InstrumentList from "./InstrumentList.vue";
import InstrumentAssignment from "./InstrumentAssignment.vue";
import InstrumentMetadata from "./InstrumentMetadata.vue";

@Component({
  components: {
    DWInstrumentNavigation,
    InstrumentList,
    InstrumentAssignment,
    InstrumentMetadata
  }
})

export default class DWInstrument extends Vue {
  $router: VueRouter;
@Prop() activeTab: string;
@Prop() navigate: (args: {tab: string}) => Location;
}
